import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 0,
    class: "tag-line"
};
const _hoisted_4 = { class: "description" };
const _hoisted_5 = { class: "description" };
const _hoisted_6 = ["src"];
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MovePanel',
    props: {
        move: {},
        customerMove: {},
        lite: { type: Boolean }
    },
    setup(__props) {
        const router = useRouter();
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass('move-panel' + (_ctx.move.shout ? ' shout' : '') + (_ctx.move.darkMode ? ' dark' : '')),
                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/Moves/' + _ctx.customerMove.id))),
                style: _normalizeStyle(_ctx.move.shout ? 'background: url(' + _ctx.move.backgroundImage + '); background-size:cover; background-position: center; background-repeat: no-repeat' : '')
            }, [
                _createElementVNode("img", {
                    src: require('@/assets/go.png'),
                    class: "goButton"
                }, null, 8, _hoisted_1),
                (!_ctx.move.shout)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "icon-col" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("img", {
                                        src: _ctx.move.thumbnail
                                    }, null, 8, _hoisted_2)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_col, { class: "right" }, {
                                default: _withCtx(() => [
                                    (_ctx.customerMove.isPending)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 0,
                                            variant: "outlined",
                                            size: "small"
                                        }, {
                                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                _createTextVNode("Not started")
                                            ])),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (!_ctx.customerMove.isPending)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 1,
                                            variant: "outlined",
                                            size: "small"
                                        }, {
                                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                _createTextVNode("Completed")
                                            ])),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "title-col" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", {
                                    class: _normalizeClass('title' + (_ctx.move.shout ? '-shout' : ''))
                                }, _toDisplayString(_ctx.customerMove.title), 3),
                                (!_ctx.lite)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.move.tagLine), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                (!_ctx.lite && _ctx.move.featureTags)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_chip, {
                                        class: "ml-1 feature-pill",
                                        variant: "outlined",
                                        size: "small"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.move.featureTags), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (!_ctx.lite)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.customerMove.description), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (_ctx.lite && _ctx.move.shout)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.customerMove.tagLine), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (!_ctx.move.shout)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 4,
                        class: "bottom-panel mt-1"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "v-col-1 timeCol" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("img", {
                                        src: require('@/assets/clock.png')
                                    }, null, 8, _hoisted_6)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.move.timeToComplete) + " minutes ", 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ], 6));
        };
    }
});
